@if (initialized) {
  <div>&nbsp;</div>
  @for (ss of siteSummaries; track ss) {
    <div>
      @if (!isSingleReport) {
        <div class="mat-body-2">SITE {{ss.site.name}}</div>
      }
      @if (!isSingleReport && !ss.summary.length) {
        <div>No records</div>
      }
      <div class="v-cards">
        @for (itSummary of ss.summary; track itSummary) {
          <ng-container [ngTemplateOutlet]="ITSummary"
          [ngTemplateOutletContext]="{ 'it': itSummary.it, 'headings': itSummary.headings, 'site': ss.site }"></ng-container>
        }
      </div>
    </div>
  }
}
<ng-template #ITSummary let-it="it" let-headings="headings" let-site="site">
  <div class="card" [ngClass]="{'active':  !it.record_by_station}" (click)="!it.record_by_station && openReportInternalTest(it, headings[0]?.heading, site)">
    <div class="mat-subtitle-1">{{it.name}}</div>
    @for (hs of headings; track hs) {
      <div class="sub-item">
        <div class="caption" (click)="openReportInternalTest(it, hs.heading, site)">
          {{hs.heading?.name}}
          @if (hs.rows) {
            ({{hs.rows}})
          }
        </div>
      </div>
    }
  </div>
</ng-template>